(function() {
  var selectors = {
    progress: '[data-cart-reward-progress]',
    message: '[data-cart-reward-message]',
    shippingFill: '[data-cart-reward-shipping-fill]',
    noveltyFill: '[data-cart-reward-novelty-fill]'
  };

  function formatYen(cents) {
    var amount = Math.max(0, Math.ceil(cents / 100));
    return '¥' + amount.toLocaleString('ja-JP');
  }

  function getState(total, freeShippingThreshold, noveltyThreshold) {
    var secondStageAmount = noveltyThreshold - freeShippingThreshold;

    if (total < freeShippingThreshold) {
      return {
        stage: 'shipping',
        shippingProgress: Math.min(100, total / freeShippingThreshold * 100),
        noveltyProgress: 0,
        message: '送料無料まであと' + formatYen(freeShippingThreshold - total)
      };
    }

    if (total < noveltyThreshold) {
      return {
        stage: 'novelty',
        shippingProgress: 100,
        noveltyProgress: Math.min(100, (total - freeShippingThreshold) / secondStageAmount * 100),
        message: '送料無料達成！10%OFFクーポンまであと' + formatYen(noveltyThreshold - total)
      };
    }

    return {
      stage: 'complete',
      shippingProgress: 100,
      noveltyProgress: 100,
      message: '送料無料＆10%OFFクーポン達成！'
    };
  }

  function updateProgress(total) {
    document.querySelectorAll(selectors.progress).forEach(function(progressEl) {
      var freeShippingThreshold = parseInt(progressEl.dataset.freeShippingThreshold, 10);
      var noveltyThreshold = parseInt(progressEl.dataset.noveltyThreshold, 10);
      var shippingFill = progressEl.querySelector(selectors.shippingFill);
      var noveltyFill = progressEl.querySelector(selectors.noveltyFill);
      var message = progressEl.querySelector(selectors.message);

      if (!freeShippingThreshold || !noveltyThreshold || !shippingFill || !noveltyFill || !message) {
        return;
      }

      var state = getState(total, freeShippingThreshold, noveltyThreshold);
      var previousStage = progressEl.dataset.progressStage || 'shipping';
      var shouldSequenceNovelty = previousStage === 'shipping' && state.stage !== 'shipping';
      var shouldSequenceShippingDecrease = previousStage !== 'shipping' && state.stage === 'shipping';
      var noveltyProgress = state.noveltyProgress;
      var updateId = (parseInt(progressEl.dataset.progressUpdateId, 10) || 0) + 1;

      progressEl.classList.remove(
        'cart-reward-progress--shipping',
        'cart-reward-progress--novelty',
        'cart-reward-progress--complete'
      );
      progressEl.classList.add('cart-reward-progress--' + state.stage);
      progressEl.dataset.totalPrice = total;
      progressEl.dataset.progressStage = state.stage;
      progressEl.dataset.progressUpdateId = updateId;

      if (shouldSequenceShippingDecrease) {
        shippingFill.style.width = '100%';
        noveltyFill.style.width = '0%';
        window.setTimeout(function() {
          if (parseInt(progressEl.dataset.progressUpdateId, 10) === updateId) {
            shippingFill.style.width = state.shippingProgress + '%';
          }
        }, 460);
      } else if (shouldSequenceNovelty) {
        shippingFill.style.width = state.shippingProgress + '%';
        noveltyFill.style.width = '0%';
        window.setTimeout(function() {
          if (parseInt(progressEl.dataset.progressUpdateId, 10) === updateId) {
            noveltyFill.style.width = noveltyProgress + '%';
          }
        }, 460);
      } else {
        shippingFill.style.width = state.shippingProgress + '%';
        noveltyFill.style.width = noveltyProgress + '%';
      }

      noveltyFill.parentNode.setAttribute(
        'aria-valuenow',
        Math.round(state.stage === 'shipping' ? state.shippingProgress : noveltyProgress)
      );
      message.textContent = state.message;
    });
  }

  function fetchCartAndUpdate() {
    var cartUrl = window.theme && theme.routes && theme.routes.cart ? theme.routes.cart : '/cart.js';

    fetch(cartUrl)
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        updateProgress(cart.total_price || 0);
      })
      .catch(function() {});
  }

  document.addEventListener('cart:updated', function(evt) {
    if (evt.detail && evt.detail.cart) {
      updateProgress(evt.detail.cart.total_price || 0);
    }
  });

  document.addEventListener('ajaxProduct:added', function() {
    window.setTimeout(fetchCartAndUpdate, 150);
  });

  document.addEventListener('cart:build', function() {
    window.setTimeout(fetchCartAndUpdate, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCartAndUpdate);
  } else {
    fetchCartAndUpdate();
  }
})();
